/**
 * @file script 相关 utils
 */
/**
 * 动态加载脚本
 *
 * @category Script
 * @param url - 脚本地址
 * @param callback - 回调函数
 */
export function loadScript(url, callback) {
    if (document.querySelector(`script[src="${url}"]`)) {
        callback();
    }
    const script = document.createElement('script');
    script.type = 'text/javascript';
    if (script.readyState) {
        // IE
        script.onreadystatechange = () => {
            if (script.readyState === 'loaded' || script.readyState === 'complete') {
                script.onreadystatechange = null;
                callback();
            }
        };
    }
    else {
        // Others
        script.onload = () => {
            callback();
        };
    }
    script.src = url;
    document.getElementsByTagName('head')[0].appendChild(script);
}
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoic2NyaXB0cy5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uLy4uL3NyYy9mdW5jdGlvbnMvc2NyaXB0cy50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFBQTs7R0FFRztBQUVIOzs7Ozs7R0FNRztBQUNILE1BQU0sVUFBVSxVQUFVLENBQUMsR0FBVyxFQUFFLFFBQW9CO0lBQzFELElBQUksUUFBUSxDQUFDLGFBQWEsQ0FBQyxlQUFlLEdBQUcsSUFBSSxDQUFDLEVBQUU7UUFDbEQsUUFBUSxFQUFFLENBQUE7S0FDWDtJQUVELE1BQU0sTUFBTSxHQUFRLFFBQVEsQ0FBQyxhQUFhLENBQUMsUUFBUSxDQUFDLENBQUE7SUFDcEQsTUFBTSxDQUFDLElBQUksR0FBRyxpQkFBaUIsQ0FBQTtJQUUvQixJQUFJLE1BQU0sQ0FBQyxVQUFVLEVBQUU7UUFDckIsS0FBSztRQUNMLE1BQU0sQ0FBQyxrQkFBa0IsR0FBRyxHQUFHLEVBQUU7WUFDL0IsSUFBSSxNQUFNLENBQUMsVUFBVSxLQUFLLFFBQVEsSUFBSSxNQUFNLENBQUMsVUFBVSxLQUFLLFVBQVUsRUFBRTtnQkFDdEUsTUFBTSxDQUFDLGtCQUFrQixHQUFHLElBQUksQ0FBQTtnQkFDaEMsUUFBUSxFQUFFLENBQUE7YUFDWDtRQUNILENBQUMsQ0FBQTtLQUNGO1NBQU07UUFDTCxTQUFTO1FBQ1QsTUFBTSxDQUFDLE1BQU0sR0FBRyxHQUFHLEVBQUU7WUFDbkIsUUFBUSxFQUFFLENBQUE7UUFDWixDQUFDLENBQUE7S0FDRjtJQUVELE1BQU0sQ0FBQyxHQUFHLEdBQUcsR0FBRyxDQUFBO0lBRWhCLFFBQVEsQ0FBQyxvQkFBb0IsQ0FBQyxNQUFNLENBQUMsQ0FBQyxDQUFDLENBQUMsQ0FBQyxXQUFXLENBQUMsTUFBTSxDQUFDLENBQUE7QUFDOUQsQ0FBQyJ9